<jhi-modal [title]="titleKey  | translate" [disabled]="isSaving">
    <div class="modal-body">
        <div class="row pt-2">
            <div class="col"><span
                    class="fw-bold">{{ headerKey | translate | uppercase }}</span>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col">
                <span [translate]="descriptionKey"></span>
            </div>
        </div>
        <div class="container-fluid px-0 pt-3">
            <jhi-study-instances-table-selector [selectAll]="selectAll" [studyInstanceItems]="studyInstanceItems"></jhi-study-instances-table-selector>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()" [disabled]="isSaving">
            <span [translate]="cancelLabelKey"></span>
        </button>
		<button *ngIf="showEditTreatmentFactors()" (click)="editTreatmentFactors()" class="btn btn-primary" [disabled]="isSaving || getSelectedInstanceIds().length === 0">
			<i *ngIf="isSaving" class="throbber throbber-btn"></i>
			<span class="ms-1" translate="study-editor.experiment.design.edit-treatment-factors"></span>
		</button>
        <button (click)="continue()" class="btn btn-primary" [disabled]="isSaving || getSelectedInstanceIds().length === 0">
            <i *ngIf="isSaving" class="throbber throbber-btn"></i>
            <span class="ms-1" [translate]="continueLabelKey"></span>
        </button>
    </div>
</jhi-modal>
